import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import * as genericUtils from '@tolk-ai/generic-utils';
import * as uiLibrary from '@tolk-ai/ui-library-react';
import * as browserUtils from '@tolk-ai/browser-utils';
import * as authentication from '@tolk-ai/identity-and-access-management-authentication';
import * as agent from '@tolk-ai/account-management-agent';

const redirectToLoginPage = (window, createAuthorizationInfos, oauthClientId, oauthRedirectUri, askedUrl) => async () => {
  const authorizationInfos = await createAuthorizationInfos(oauthClientId, oauthRedirectUri, askedUrl);
  window.location.assign(authorizationInfos.loginUrl);
};

const onInit = (window, createAuthorizationInfos, oauthClientId, oauthRedirectUri, askedUrl, refreshAccessToken, setIsLoading) => async () => {
  if (browserUtils.isAccessTokenExpired() === false) {
    window.location.assign('/');
    return;
  }

  if (browserUtils.isAccessTokenExpired() === true) {
    setIsLoading(true);

    try {
      await refreshAccessToken();
      window.location.assign(askedUrl);
    } catch (_a) {
      await redirectToLoginPage(window, createAuthorizationInfos, oauthClientId, oauthRedirectUri, askedUrl)();
    }

    return;
  }

  await redirectToLoginPage(window, createAuthorizationInfos, oauthClientId, oauthRedirectUri, askedUrl)();
};

const onAuthorizationCode = (window, completeAuthenticationProcess, setErrorMessage) => async (state, code) => {
  const result = await completeAuthenticationProcess(code, state);

  if (genericUtils.isDomainError(result, authentication.appPorts.CompleteAuthenticationProcessErrors)) {
    switch (result) {
      case authentication.appPorts.CompleteAuthenticationProcessErrors.inexistingAuthorizationInfos:
        window.location.assign('/');
        return;
    }

    setErrorMessage(`Unable to complete authentication process (${authentication.appPorts.CompleteAuthenticationProcessErrors[result]})`);
    return;
  }

  window.location.assign(result.askedUrl);
};

var styles = {"form__loading":"index-module_form__loading__Ls7pd"};

const container$1 = (window, createAuthorizationInfos, completeAuthenticationProcess, oauthClientId, oauthRedirectUri, refreshAccessToken) => () => {
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  React.useEffect(() => {
    const {
      searchParams
    } = new URL(window.location.href);
    const code = searchParams.get('code');
    const askedUrl = window.location.href;

    if (genericUtils.isString(code)) {
      void onAuthorizationCode(window, completeAuthenticationProcess, setErrorMessage)(searchParams.get('state'), code);
      return;
    }

    void onInit(window, createAuthorizationInfos, oauthClientId, oauthRedirectUri, askedUrl, refreshAccessToken, setIsLoading)();
  }, []);
  return jsxs(Fragment, {
    children: [isLoading === true && jsx(uiLibrary.icon.Component, {
      className: styles.form__loading,
      icon: "spinner"
    }, void 0), errorMessage !== null && jsx(uiLibrary.toast.Container, {
      children: errorMessage
    }, void 0)]
  }, void 0);
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  container: container$1
});

const Component = ({
  agentUrl,
  analyticsReactBaseUrl,
  appName,
  botUrl,
  getAgentSsoUrl
}) => {
  return jsx(uiLibrary.dropdown.Container, Object.assign({
    defaultText: "Tolk's apps",
    icon: {
      name: 'ViewGridIcon',
      type: 'icon-only'
    },
    onOpening: getAgentSsoUrl,
    value: ""
  }, {
    children: jsxs(Fragment, {
      children: [appName !== 'bot' && jsx(uiLibrary.dropdown.element.Container, Object.assign({
        icon: {
          name: 'logo:bot'
        },
        url: {
          linkTo: botUrl,
          target: '_self'
        }
      }, {
        children: "Bot"
      }), void 0), appName !== 'analytics' && jsx(uiLibrary.dropdown.element.Container, Object.assign({
        icon: {
          name: 'logo:analytics'
        },
        url: {
          linkTo: analyticsReactBaseUrl,
          target: '_blank'
        }
      }, {
        children: "Analytics"
      }), void 0), appName !== 'agent' && jsx(uiLibrary.dropdown.element.Container, Object.assign({
        icon: {
          name: 'logo:agent'
        },
        url: {
          linkTo: agentUrl,
          target: '_blank'
        }
      }, {
        children: "Agent"
      }), void 0)]
    }, void 0)
  }), void 0);
};

const getAgentSsoUrl = (getOneAgentInfosByUserAccountId, setAgentUrl, setFeedback) => userId => async () => {
  try {
    const result = await getOneAgentInfosByUserAccountId(userId);

    if (genericUtils.isDomainError(result, agent.appPorts.GetOneAgentUserInfosErrors)) {
      switch (result) {
        case agent.appPorts.GetOneAgentUserInfosErrors.inexistingAgentUserInfos:
          setAgentUrl('https://www.tolk.ai/agent-plateforme-livechat');
          break;

        default:
      }

      return;
    }

    setAgentUrl(result.ssoUrl);
  } catch (_a) {
    setFeedback('An error occured, please retry');
  }
};

const container = (analyticsReactBaseUrl, getOneAgentInfosByUserAccountId, botUrl) => ({
  userId,
  appName
}) => {
  const [feedback, setFeedback] = React.useState('');
  const [agentUrl, setAgentUrl] = React.useState('');
  return jsxs(Fragment, {
    children: [feedback !== '' && jsx(uiLibrary.toast.Container, Object.assign({
      autoHide: {
        delay: 5000,
        isActive: true,
        onHide: () => setFeedback('')
      },
      position: {
        location: 'bottom-left'
      },
      type: "danger"
    }, {
      children: feedback
    }), void 0), jsx(Component, {
      agentUrl: agentUrl,
      analyticsReactBaseUrl: analyticsReactBaseUrl,
      appName: appName,
      botUrl: botUrl,
      getAgentSsoUrl: getAgentSsoUrl(getOneAgentInfosByUserAccountId, setAgentUrl, setFeedback)(userId)
    }, void 0)]
  }, void 0);
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  container: container
});

export { index$1 as login, index as tolkMenu };
